// 印章授权
<template>
  <div class="seal-manage">
    <div class="seal-wrap" :style="isInDingTalk ? 'height: 72vh' : ''">
      <div class="box-right">
        <div style="background: #ffffff">
          <h1 class="com-title com-ht" style="padding-top: 20px">
            <span><i></i>用章的审批流程-{{ oneSealInfo.signName }}</span>
            <el-button type="primary" plain size="small" :disabled="!perms.includes(103)" @click="$emit('editApproveFn',oneSealInfo)"
              >{{(oneSealInfo.flowId || oneSealInfo.dingTalkFlow) ? '修改' : '添加用印审批流程'}}</el-button
              >
          </h1>
          <!--  v-if="currentProcess && currentProcess.useStatus !== 1" -->
          <div class="liucheng-box" v-if="flowInfo.length">
            <!-- v-if="currentProcess" -->
            <p class="text">
              <span class="dian" v-show="currentProcess && currentProcess.flowName"></span>
              <span>{{ currentProcess ? currentProcess.flowName : '' }}</span>
              <span v-show="currentProcess && currentProcess.useStatus">{{ currentProcess && currentProcess.useStatus === 1 ? "（已停用）" : "" }}</span>
            </p>
            <div>
              <approval-process
                :flowInfo="flowInfo"
                :orderFlag="oneSealInfo.flowDetail && !isInDingTalk
                          ? oneSealInfo.flowDetail.orderFlag
                          : (oneSealInfo.dingTalkFlow ? oneSealInfo.dingTalkFlow.flowType : '')"
              ></approval-process>
            </div>
          </div>
          <div v-else style="text-align: center; padding: 40px 0 10px 0">
            <p>若未添加审批流程，用章时无需审批，</p>
            <p>可直接使用该印章进行文件签署</p>
          </div>
        </div>
        <div style="height: 15px; width: 100%; background: #f5f5f5"></div>
        <div style="background: #ffffff">
          <h1 class="com-title com-ht">
            <span><i></i>印章授权-{{ oneSealInfo.signName }} <span>&nbsp;&nbsp;/仅对我管理的部门成员印章授权</span></span>
            <span>
              <el-button size="small" @click="chooseCancelAuth()"
                >取消授权</el-button
              >
              <el-tooltip placement="bottom" effect="light">
                <div slot="content">
                  将印章授权给企业成员，<br />该成员即可代表企业使<br />用印章进行文件签署。
                </div>
                <el-button
                  type="primary"
                  size="small"
                  plain
                  @click="initMemberForm()"
                  >授权给成员</el-button
                >
              </el-tooltip>
            </span>
          </h1>
          <el-table
            :data="sealUsers"
            style="
              border: 1px solid #eeeeee;
              border-bottom: 0;
              margin-top: 30px;
            "
            tooltip-effect="dark"
            @selection-change="handleSelectionChange0"
            :header-cell-style="{
              background: '#f9f9f9',
              color: '#333333',
              fontWeight: '600',
            }"
          >
            <el-table-column
              type="selection"
              width="55"
              :selectable="
                (row, index) => (row.canBeAuthorized != 1 ? false : true)
              "
            ></el-table-column>
            <el-table-column label="名称" show-overflow-tooltip>
              <template slot-scope="scope">
                {{ scope.row.userName }}
                <span v-if="scope.row.targetId != ''">{{
                  `(${scope.row.targetId})`
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="部门"
              prop="groupNames"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column label="操作">
              <div slot-scope="scope">
                <span
                  @click="chooseCancelAuth(scope.row, true)"
                  style="cursor: pointer"
                  class="color-danger"
                  :class="{
                    'dis-sty':
                      !btnEven || (btnEven && scope.row.canBeAuthorized !== 1),
                  }"
                  >取消授权</span
                >
              </div>
            </el-table-column>
            <no-data text="暂无数据" slot="empty" />
          </el-table>
          <el-row class="pageation" v-if="pageTotalLt > 0">
            <el-col :span="24" style="padding: 30px 0" class="page-flex-end">
              <el-pagination
                @size-change="handleSizeChangeLt"
                @current-change="handleCurrentChangeLt"
                :current-page="itemPageLt"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pageSizeLt"
                layout="sizes, prev, pager, next, total"
                :total="pageTotalLt"
              />
              <el-go
                :page-size="pageSizeLt"
                :total="pageTotalLt"
                @current-change="handleCurrentChangeLt"
              ></el-go>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>

    <el-dialog title="关联审批" :visible.sync="authDialogVisible" width="45%" :append-to-body="true">
      <p
        style="
          font-size: 14px;
          font-weight: 400;
          line-height: 24px;
          color: #290202;
          margin-bottom: 10px;
        "
      >
        <i class="warn-img el-icon-warning"></i>
        将印章与用印审批流程关联，使用印章签署文件时需先进行审批，<span
          class="addsign"
          @click="turnToSP"
          >新增用印审批流程>></span
        >
      </p>
      <ul class="liuChengUl">
        <li
          v-for="(item, index) in processList"
          :key="index"
          @click="choosedProcess = item"
          :style="
            choosedProcess && choosedProcess.flowId == item.flowId
              ? 'background:#f1f1f1'
              : ''
          "
        >
          <img src="../../../static/images/icon/icon-liucheng.jpg" alt="" />{{
            item.flowName
          }}
        </li>
      </ul>

      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="chooseProcess()"
          >确认</el-button
        >
        <el-button size="mini" @click="authDialogVisible = false"
          >取消</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      title="印章授权"
      :visible.sync="ChooseDialogVisible"
      top="5vh"
      width="60%"
      :append-to-body="true"
    >
      <p
        style="
          font-size: 14px;
          font-weight: 400;
          line-height: 24px;
          color: #290202;
          margin-bottom: 20px;
        "
      >
        <i class="warn-img el-icon-warning"></i>
        将印章授权给选中成员，被选中的成员则可以使用印章签署文件
      </p>

      <el-form
        size="small"
        :inline="true"
        :model="memberForm"
        class="demo-form-inline"
        style="margin: -10px 0 10px 0; text-align: right"
      >
        <el-form-item>
          <el-input
            style="width: 220px"
            v-model="memberForm.targetId"
            placeholder="邮箱/手机号"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            style="width: 220px"
            v-model="memberForm.userName"
            placeholder="签署方名称"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item>
          <el-select
            v-model="memberForm.corpGroupId"
            placeholder="请选择部门"
            style="width: 150px"
          >
            <el-option label="全部" :value="-1" />
            <el-option
              v-for="(item, index) in treeGroups"
              :key="index"
              :label="item.groupName"
              :value="item.corpGroupId"
            />
          </el-select>
        </el-form-item> -->
        <el-form-item style="margin-right: 0px">
          <el-button @click="getCmSealUsers(0)">查询</el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
      <el-table
        :data="unSealUsers"
        style="border: 1px solid #eeeeee; border-bottom: 0; margin-top: -15px"
        tooltip-effect="dark"
        @selection-change="handleSelectionChange"
        :header-cell-style="{
          background: '#f9f9f9',
          color: '#333333',
          fontWeight: '600',
        }"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column
          label="邮箱/手机号"
          show-overflow-tooltip
          prop="targetId"
        ></el-table-column>
        <el-table-column
          label="名称"
          show-overflow-tooltip
          prop="userName"
        ></el-table-column>
        <el-table-column
          label="部门"
          prop="groupNames"
          show-overflow-tooltip
        ></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="ChooseMember(1)"
          >确认</el-button
        >
        <!--        <el-button size="mini" @click="ChooseDialogVisible=false">取消</el-button>-->
      </span>
      <el-row class="pageation" v-if="pageTotal > 0">
        <el-col :span="24" style="padding: 30px 0" class="page-flex-end">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="itemPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="sizes, prev, pager, next, total"
            :total="pageTotal"
          />
          <el-go
            :page-size="pageSize"
            :total="pageTotal"
            @current-change="handleCurrentChange"
          ></el-go>
        </el-col>
      </el-row>
    </el-dialog>

    <el-dialog
      title="取消授权"
      :visible.sync="cancelAuthDialogVisible"
      width="30%"
      :append-to-body="true"
    >
      <span>是否取消授权？</span>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="cancelAuthDialogVisible = false"
          >取消</el-button
        >
        <el-button size="mini" type="primary" @click="cancelAuth()"
          >确认</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      title="取消审批流程"
      :visible.sync="cancelAuthProcessDialogVisible"
      width="30%"
      :append-to-body="true"
    >
      <span>是否取消盖章审核流程？</span>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="cancelProcess()"
          >确认</el-button
        >
        <el-button size="mini" @click="cancelAuthProcessDialogVisible = false"
          >取消</el-button
        >
      </span>
    </el-dialog>
    <!-- 选择印章 -->
    <el-dialog title="选择印章（可多选）" :visible.sync="showEditSeal" :append-to-body="true">
      <div class="checkbox">
        <div
          v-for="(item, index) in chapterList"
          class="temone"
          :key="index"
          :style="
            chapterChecked.includes(item.signId)
              ? 'border: 1px solid #d9001b;'
              : ''
          "
          @click="checkChange(item.signId)"
        >
          <div class="t-box">
            <!-- 签章 -->
            <img class="y-img" :src="item.signUrl" :title="item.signName" />
          </div>
          <p
            :title="`${item.signName}(ID:${item.signId})`"
            :style="
              chapterChecked.includes(item.signId)
                ? 'background-color:#d9001b;color:#fff'
                : ''
            "
          >
            {{ `${item.signName}(ID:${item.signId})` }}
          </p>
        </div>
      </div>

      <span slot="footer" class="dialog-footer cha-footer">
        <span
          >已选择<span style="color: red">{{ chapterChecked.length }}</span
          >个</span
        >
        <div>
          <el-button
            size="mini"
            type="primary"
            :loading="btnLoading"
            @click="chooseChapter"
            >确认</el-button
          >
          <el-button size="mini" @click="showChange">取消</el-button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  fileOperShow,
  postFileTempUpload
} from "@/assets/js/http-serve/http-methods";
import { ApiCorpMethods } from "@/assets/js/http-serve/corp/http-methods";
import EntSignController from "@/assets/js/http-serve/entSignController";
import showRes from "@/assets/js/http-serve/corp/showApiRes";
import { getFix } from "@/assets/js/lib/common";
import auditDetail from "@/components/auditDetail/index";
import approvalProcess from "@/components/approval-process/index";
import ElGo from "../../go/Go";
import { gantConf, getPermInfo } from "../../../assets/js/utils/jurisdiction";
import { mapGetters } from "vuex";
import { isInDingTalk } from "../../../assets/js/utils/ding-env";

export default {
  name: "seal",
  components: {
    auditDetail,
    approvalProcess,
    ElGo
  },
  props: {
    sealInfo:{
      type:Object,
      default:() => ({})
    }
  },
  data () {
    return {
      gantConf,
      isInDingTalk,
      // 未使用的签章列表
      chapterList: [],
      // 选中的签章
      chapterChecked: [],
      btnLoading: false,
      memberForm: {
        targetId: "",
        userName: "",
        corpGroupId: -1
      },
      sealUsers: [],
      unSealUsers: [],
      ChooseDialogVisible: false,
      authDialogVisible: false,
      cancelAuthDialogVisible: false,
      cancelAuthProcessDialogVisible: false,
      processList: [],
      currentProcess: null,
      choosedProcess: null,
      sealSp: false,
      height: "100%",
      selectionRow: null,
      selectionRow0: null,
      tableList: [],
      showAdd: false,
      sealLoading: false,
      oneSealInfo: {},
      showEditSeal: false,
      uploadLoading: false,
      dialogTitle: "添加签章",
      chapterParam: {
        targetId: null,
        targetFix: null,
        signName: null,
        signId: null,
        sealUrl: ""
      }, //保存、添加签章的参数
      seals: [],
      fileOperShow: fileOperShow,
      flowInfo: [],
      Copys: [],
      corpUserIdSetId: "",
      itemPage: 1,
      pageTotal: 0,
      pageSize: 10,
      itemPageLt: 1,
      pageTotalLt: 0,
      pageSizeLt: 10,
      treeGroups: []
    };
  },
  beforeMount () {
    // this.initTreeGroup();
    // this.getAllSeals();
    // this.getWindowHeight();
    // this.getProcessList();
  },
  methods: {
    emitAuthListFn() {
      // 签章授权
      this.$emit("update:tabAct", "mianSign");
    },
    // 选择签章
    checkChange (signId) {
      let arr = this.chapterChecked;
      let index = arr.indexOf(signId);
      // 存在就删除该元素
      index > -1 ? arr.splice(index, 1) : arr.push(signId);
    },
    // 添加签章
    chooseChapter () {
      if (this.chapterChecked.length == 0) return;
      this.btnLoading = true;
      let params = this.chapterChecked.toString();
      EntSignController.allowMemberUse(params)
        .then(res => {
          if (!res.success) return;
          this.chapterChecked = [];
          this.getAllSeals();
          this.btnLoading = false;
          this.showEditSeal = false;
        })
        .catch(err => {
          this.btnLoading = false;
        });
    },
    // 添加签章窗口取消按钮
    showChange () {
      this.showEditSeal = !this.showEditSeal;
      this.chapterChecked = [];
    },
    turnToSP () {
      this.authDialogVisible = false;
      let hasFlow = this.$store.getters.consoleToken.perms.some(i => +i == 12);
      if (hasFlow) {
        this.$router.replace({
          path: "/console/flow",
          query: { flowType: 1 }
        });
      } else {
        this.$message.info("您还没有此权限，请开通后重试");
      }
    },
    delShenPi () {
      this.cancelAuthProcessDialogVisible = true;
    },
    cancelProcess () {
      //是否选中审批
      this.cancelAuthProcessDialogVisible = false;
      this.chooseProcess(true);
    },
    initMemberForm () {
      const bool = this.permsEven()
      if (!bool) return
      this.ChooseDialogVisible = true;
      this.memberForm = {
        targetId: "",
        userName: "",
        corpGroupId: -1
      };
      this.getCmSealUsers(0);
    },
    initTreeGroup () {
      let params = {};
      params.permId = 4;
      ApiCorpMethods.OrganizationController.treeGroup(params)
        .then(res => {
          if (+res.code === 0) {
            this.convertFormateTree(res.data);
          } else {
            this.$message.error(res.description);
          }
        })
        .catch(error => {
          this.$message({ type: "error", message: error.description });
        });
    },
    convertFormateTree (tree) {
      tree.forEach(i => {
        this.treeGroups.push({
          corpGroupId: i.corpGroupId,
          groupName: i.groupName
        });
        if (i.childCorpGroups && i.childCorpGroups.length !== 0)
          this.convertFormateTree(i.childCorpGroups);
      });
    },
    // 重置
    reset () {
      this.memberForm = {
        targetId: "",
        userName: "",
        corpGroupId: -1
      };
      this.getCmSealUsers(0);
    },
    getCmSealUsers (auth) {
      const { targetId, userName, corpGroupId } = this.memberForm;
      ApiCorpMethods.SealController.cmSealUsers({
        corpSealId: this.oneSealInfo.corpSealId,
        targetId,
        userName,
        corpGroupId: corpGroupId === -1 ? "" : corpGroupId,
        auth: auth,
        itemPage: auth === 0 ? this.itemPage : this.itemPageLt,
        pageSize: auth === 0 ? this.pageSize : this.pageSizeLt
      }).then(res => {
        if (!res.success)
          return this.$message.error("系统图形章无法授权，请先创建印章！");
        auth === 1 &&
          (this.sealUsers = res.data) &&
          (this.pageTotalLt = res.total);
        auth === 0 &&
          (this.unSealUsers = res.data) &&
          (this.pageTotal = res.total);
      });
    },
    /** 获取审批流程列表数据 */
    getProcessList () {
      ApiCorpMethods.FlowController.pageFlow({
        itemPage: 1,
        pageSize: 1000,
        flowType: 1
      }).then(res => {
        if (!res.success) return;
        this.processList = res.data.filter(i => +i.useStatus === 0);
      });
    },
    /** 获取已选流程 */
    getFlowInfo () {
      ApiCorpMethods.SealController.flowInfo({flowId: this.oneSealInfo.flowId}).then(res => {
        this.flowInfo = res.data ? res.data.partyList : [];
        this.Copys = (res.data || {}).copyToList || [];
        !this.currentProcess && (this.currentProcess = {});
        this.currentProcess.flowName = res.data ? res.data.flowName : "";
        this.currentProcess.useStatus = res.data ? res.data.useStatus : 0;
        res.data && (this.currentProcess.orderFlag = res.data.orderFlag);
      });
    },
    /**
     *  选择审批流程
     *  status:true 为取消审批流程, false 为选择审批流程
     * */
    chooseProcess (status) {
      if (!status && !this.choosedProcess)
        return this.$message.error("请选择流程");
      this.sealSp = false;
      ApiCorpMethods.SealController.cmApproveSeal({
        corpSealId: this.oneSealInfo.corpSealId,
        auth: !status ? 1 : 0, // 1设置审核，0取消审核
        flowId: !status ? this.choosedProcess.flowId : "" // 审核时传id，取消审核传空
      }).then(res => {
        if (res.code == 0 && !status) {
          // 选择审批流程
          this.currentProcess = this.choosedProcess;
          this.authDialogVisible = false;
          // this.sealSp = true
          this.getAllSeals();
          return this.$message.success(res.description);
        } else if (res.code != 0) return this.$message.error(res.description);
        this.getAllSeals();
      });
    },
    ChooseMember (auth, id) {
      if (auth === 1) {
        // 清空
        this.memberForm.targetId = "";
        this.memberForm.userName = "";
        this.memberForm.corpGroupId = -1;
      }
      let corpUserIdSet = id || this.corpUserIdSet();
      if (!corpUserIdSet || corpUserIdSet === "")
        return this.$message.error("请选择持有人");
      ApiCorpMethods.SealController.cmGrantOrRevokeSeal({
        corpSealId: this.oneSealInfo.corpSealId,
        corpUserIdSet: corpUserIdSet,
        auth: auth
      }).then(res => {
        if (res.code != 0) return this.$message.error(res.description);
        this.ChooseDialogVisible = false;
        if (id) {
          this.cancelAuthDialogVisible = false;
        }
        this.getAllSeals();
        return this.$message.success(res.description);
      });
    },
    corpUserIdSet (n) {
      //处理多用户id
      let corpUserIdSet = "";
      let arr = n === 0 ? this.selectionRow0 : this.selectionRow;
      for (let i in arr) {
        corpUserIdSet += arr[i].corpUserId + ",";
      }
      return corpUserIdSet;
    },
    getWindowHeight () {
      this.height = window.innerHeight - 110 + "px";
    },
    handleSelectionChange (val) {
      this.selectionRow = val;
    },
    handleSelectionChange0 (val) {
      this.selectionRow0 = val;
    },
    chooseCancelAuth (row, choose) {
      const bool = this.permsEven()
      if (!bool) return
      if (row && row.canBeAuthorized !== 1) return this.$message.warning('暂无当前员工所在部门管理权限，如需使用请联系管理员修改权限范围')
      let id = row ? row.corpUserId : this.corpUserIdSet(0);
      if (!id) return this.$message.error("请先勾选成员");
      this.corpUserIdSetId = id;
      if (!this.cancelAuthDialogVisible)
        return (this.cancelAuthDialogVisible = true);
    },
    cancelAuth () {
      this.ChooseMember(0, this.corpUserIdSetId);
    },
    async getAllSeals () {
      this.getCmSealUsers(1);
      this.$emit('getAuthSealList');
      (!isInDingTalk && this.oneSealInfo.flowId) && this.getFlowInfo();
      return;
      let res = await ApiCorpMethods.SealController.seals();
      if (!res.success) {
        showRes(res);
        return;
      }
      let seals = res.data;
      seals.forEach(seal => {
        seal.sealUrl = fileOperShow(seal.sealFile);
      });
      seals.sort((a, b) => {
        return a.corpSealId - b.corpSealId;
      });
      //默认选择的值排前defaultTemId
      seals.sort((item) => {
        return item.corpSealId === this.defaultTemId ? -1 : 1;
      });
      this.seals = seals;
      if (!this.seals[0]) return;
      let n_index = 0;
      console.log('sealInfo::::',this.sealInfo);

      if (this.oneSealInfo.corpSealId) {
        this.seals.forEach((i, index) => {
          if (this.oneSealInfo.corpSealId === i.corpSealId) {
            n_index = index;
            this.oneSealInfo = i;
          }
        });
      } else {
        this.oneSealInfo = this.seals[0];
      }
      this.flowInfo = [];
      (!isInDingTalk && this.oneSealInfo.flowId) && this.getFlowInfo();
      this.getCmSealUsers(1);
      //点击第一个角色
      this.$nextTick(() => {
        let roleMenu = document.getElementById("sealMenu" + n_index);
        if (roleMenu && roleMenu.click) {
          roleMenu.click();
        }
      });
    },
    getOneSeal (item) {
      // console.log('item::::',item);
      this.oneSealInfo = item;
      this.currentProcess = null;
      this.flowInfo = this.computeInfo(item);
      if(isInDingTalk){
        this.currentProcess = item.dingTalkFlow;
      }else{
        if(item.flowDetail) this.oneSealInfo.flowId = item.flowDetail.flowId;
        (this.oneSealInfo.flowId) && this.getFlowInfo();
      }
      this.getCmSealUsers(1);
      // this.getCmSealUsers(0);
    },
    computeInfo(obj) {
      if (!obj) return []
      const {flowDetail: flow, dingTalkFlow: dingFlow} = obj;
      let nameList = [];
      if (!isInDingTalk && flow) nameList = flow.orderFlag ? flow.allPartName.split("->") : flow.allPartName.split("、");
      if (isInDingTalk && dingFlow) {
        const {nodes} = dingFlow.flowParam;
        nodes && nodes.forEach((node) => {
          nameList.push(...(node.userApproveUsers.map(user => user.name)))
        })
      }
      const list = nameList.map(name => {
        return {
          partyName: name
        };
      });
      return list;
    },
    async handleSealSuccess (res, file) {
      let param = { file: file.raw, fileType: 1 };
      let { fix } = getFix(param.file.name);
      this.chapterParam.sealUrl = URL.createObjectURL(param.file);
      this.chapterParam.targetFix = fix;
      //上传临时文件
      this.uploadLoading = true;
      let temRes = await postFileTempUpload(param);
      this.uploadLoading = false;
      if (!temRes.file || !temRes.fileType) return showRes(temRes);
      this.chapterParam.targetId = temRes.targetId;
    },
    beforeSealUpload (file) {
      const isJPG = file.type === "image/png";
      const isLt10M = file.size / 1024 / 1024 <= 1;

      if (!isJPG) {
        this.$message.error("签章图片格式错误！");
      }
      if (!isLt10M) {
        this.$message.error("上传签章图片大小不能超过 1MB!");
      }
      return isJPG && isLt10M;
    },
    handleSizeChange (val) {
      this.pageSize = val;
      this.getCmSealUsers(0);
    },
    handleCurrentChange (val) {
      this.itemPage = val;
      this.getCmSealUsers(0);
    },
    handleSizeChangeLt (val) {
      this.pageSizeLt = val;
      this.getCmSealUsers(1);
    },
    handleCurrentChangeLt (val) {
      this.itemPageLt = val;
      this.getCmSealUsers(1);
    },
    permsEven (pid = gantConf.sealAuth) {
      const perms = this.perms;
      const bool = perms.includes(pid);
      if (!bool) {
        const Pinfo = getPermInfo(pid)
        this.$message.warning(`暂无【${Pinfo.name}】权限，如需使用请联系管理员开通`)
      }
      return bool
    }
  },
  computed: {
    ...mapGetters(["currentAuthUser", "allAuthUser"]),
    perms () {
      return this.currentAuthUser.perms ? this.currentAuthUser.perms : [];
    },
    btnEven () {
      const perms = this.perms;
      const bool = perms.includes(gantConf.sealAuth);
      return bool;
    }
  },
  watch: {
    sealInfo:{
      handler(val){
        this.getOneSeal(val)
      },
      immediate:true,
      deep:true
    }
  },
};
</script>

<style lang="less" scoped>
.second_btn {
  z-index: 10;
  display: inline-block;
  border: 1px solid #ec1c1c;
  padding: 5px 22px;
  border-radius: 4px;
  font-size: 12px;
  color: #ec1c1c;
  cursor: pointer;
  margin-left: 10px;
  &:hover {
    color: #ffffff;
    background-color: #ec1c1c;
  }
}
.color-danger {
  color: #290202;
  font-weight: bold;
}

.color-danger:hover {
  color: #ec1c1c;
}
.dis-sty {
  color: #ccc !important;
  cursor: not-allowed !important;
}
.custom-checkbox {
  /deep/ .el-checkbox__label {
    color: #606266;
  }
}

.approvalProcess {
  margin-bottom: 10px;

  .text {
    img {
      vertical-align: unset;
      margin-right: 6px;
    }
  }
}

.liuChengUl {
  li {
    margin-bottom: 5px;
    padding: 3px;
    cursor: pointer;

    &.active {
      border-radius: 3px;
      background-color: #eee;
    }

    img {
      vertical-align: unset;
      margin-right: 6px;
    }
  }
}

.oneSealInfo {
  .name {
    color: #333333;
    font-weight: bold;
    margin-right: 21px;
  }

  span {
    cursor: pointer;
    color: #9a9a9a;
    margin-right: 25px;

    i {
      color: #676767;
      margin-right: 7px;
    }
  }
}

.user-menu {
  border-right: 1px solid #e4e7ed;

  .my-menu {
    border-right: none;
    text-align: center;

    .is-active {
      color: #ec1c1c;
      border-right: 2px solid #ec1c1c;
      background: #f2f2f2;
    }
  }

  .user-icon {
    text-align: left;
    color: #656565;
    font-size: 16px;
    font-weight: bold;
  }

  .user-add {
    text-align: right;
    color: #ec1c1c;
    font-size: 14px;
    cursor: pointer;
  }
}

.seal-manage {
  .name {
    color: rgb(102, 102, 102);
    font-weight: bold;
    white-space: nowrap;
    overflow-x: auto;
    height: 34px;
  }

  .id {
    color: rgb(152, 152, 152);
    font-size: 12px;
  }

  .seal-wrapper {
    position: relative;
    text-align: center;
    margin-top: 28px;
    width: 180px;
    height: 180px;
    border: 1px solid rgba(204, 204, 204, 1);
    border-radius: 4px;

    img {
      max-width: 70%;
      max-height: 90%;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
    }
  }

  .handles {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    border-top: solid 1px #eee;

    .el-button {
      width: 100%;
      text-align: center;
      padding: 10px 0;
      border: none;
      font-size: 12px;
    }

    &:after {
      position: absolute;
      top: 50%;
      left: 50%;
      margin-top: -7px;
      content: "";
      display: inline-block;
      width: 1px;
      height: 14px;
      background-color: #eee;
    }
  }

  .v-line {
    width: 4px;
    height: 60px;
    max-height: 80%;
    background-color: #d8d8d8;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -2px;
    margin-top: -30px;
    border-radius: 2px;
  }

  .h-line {
    width: 60px;
    height: 4px;
    max-height: 80%;
    background-color: #d8d8d8;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -30px;
    margin-top: -2px;
    border-radius: 2px;
  }

  .add-seal {
    /deep/ .el-dialog__body {
      padding-bottom: 70px;

      .el-row {
        line-height: 2;
      }
    }

    /deep/ .foot-btns {
      position: absolute;
      width: 100%;
      left: 0;
      bottom: 0;
      padding: 10px 25px;
      text-align: right;
      border-style: solid;
      border-color: #eee;
      border-width: 1px 0 0 0;

      .el-button {
        padding: 8px 15px;
      }
    }

    .seal-input {
      width: 320px;
      max-width: calc(100% - 90px);
    }

    .label {
      display: inline-block;
      width: 90px;
      text-align: right;

      .require {
        color: red;
        vertical-align: middle;
      }
    }

    .seal-upload {
      margin-top: 20px;
    }

    /deep/ .seal-uploader {
      display: inline-block;
      vertical-align: top;
      width: 178px;
      max-width: calc(100% - 90px);

      .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        width: 100%;
        height: 0;
        padding-bottom: 100%;
        background-color: rgb(242, 242, 242);

        &:hover {
          border-color: #409eff;
        }

        .seal {
          max-width: 90%;
          max-height: 90%;
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          margin: auto;
        }
      }
    }

    .seal-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 100%;
      height: 0;
      padding-bottom: 100%;
      text-align: center;

      &:before {
        width: 50px;
        height: 50px;
        max-width: 100%;
        line-height: 50px;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
      }
    }

    .upload-tip {
      color: rgb(153, 153, 153);
      font-size: 12px;
      padding-left: 90px;
    }
  }
}

.list-enter-active,
.list-leave-active {
  transition: all 0.3s;
}

.list-enter,
.list-leave-to {
  opacity: 0;
}

.list-move {
  transition: all 0.4s;
}

.list-leave-active {
  position: absolute;
}

.mainUl {
  width: 100%;
  display: inline-block;

  li {
    text-align: center;
    width: 100px;
    position: relative;
    margin-right: 60px;
    float: left;

    .people {
      margin: 20px auto;

      img {
        width: 46px;
        height: 46px;
      }
    }

    .p1 {
      margin-bottom: 10px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .p2 {
      margin-bottom: 10px;
    }
    .btn-margin {
      margin: 7px 0;
    }
  }

  .next:after {
    content: "";
    background: url("../../../static/images/jiantou32.png") no-repeat;
    background-size: contain;
    width: 24px;
    height: 20px;
    display: inline-block;
    position: absolute;
    right: -40px;
    top: 35px;
  }
}

/*sass大改改版*/
.seal-wrap {
  position: relative;
  .box-right {
    min-height: 600px;
    box-sizing: border-box;
    /*height: calc(100vh - 200px);*/
    color: rgba(41, 2, 2, 1);
    background: rgba(255, 255, 255, 1);
    /*overflow-y: scroll;*/
    .liucheng-box {
      box-sizing: border-box;
      padding: 25px 15px;
      .text {
        font-size: 16px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }
    }
    .el-icon-error {
      margin-left: 11px;
      font-size: 20px;
      color: #b7b7b7;
      cursor: pointer;
      &:hover {
        color: rgba(236, 28, 28, 1);
      }
    }
  }
}

.com-title {
  display: flex;
  justify-content: space-between;
  align-content: center;
  padding-right: 20px;
  box-sizing: border-box;
  .com-a-btn-default,
  .com-a-btn {
    width: 120px;
    margin-left: 10px;
  }
}

.dian {
  display: inline-block;
  vertical-align: middle;
  width: 5px;
  height: 5px;
  background: rgba(41, 2, 2, 1);
  border-radius: 50%;
  opacity: 1;
  margin-right: 5px;
}

.warn-img {
  color: #e6a23c;
  font-size: 18px;
}
.warn-img::before {
  content: "\E7A3";
}

.addsign {
  cursor: pointer;
  font-family: Source Han Sans SC;
  font-weight: 700;
  color: #290202;
  &:hover {
    color: #ec1c1c;
  }
}
.checkbox {
  display: flex;
  flex-wrap: wrap;
}
.temone {
  margin-left: 20px;
  margin-top: 15px;
  width: 175px;
  text-align: center;
  align-items: center;
  border: 1px solid rgba(238, 238, 238, 1);
  border-radius: 4px;
  height: 180px;
  &.add {
    cursor: pointer;
    height: 142px;
    line-height: 140px;
    display: flex;
    justify-content: center;
    align-items: center;
    &:hover {
      box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.28);
    }
  }
  p {
    font-size: 14px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding: 0 10px;
    width: 100%;
    font-family: Source Han Sans SC;
    box-sizing: border-box;
    // height: 35px;
    // line-height: 35px;
    background: rgba(239, 239, 239, 1);
    color: rgba(41, 2, 2, 0.65);
  }
  .t-box {
    position: relative;
    width: 100%;
    height: 105px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    &:hover {
      .msk {
        width: 100%;
        height: 100%;
        opacity: 1;
      }
    }
    .y-img {
      /*width: 106px;*/
      /*min-height: 100px;*/
      width: 96px;
      height: auto;
      display: block;
      margin: 8px auto 7px auto;
    }
    .msk {
      transition: all ease 0.2s;
      position: absolute;
      left: 0;
      top: 0;
      width: 0;
      height: 0;
      background: rgba(0, 0, 0, 0.5);
      opacity: 0;
      padding: 8px 8px;
      box-sizing: border-box;
      z-index: 10;
      span {
        cursor: pointer;
        float: right;
        color: #ffffff;
        font-size: 20px;
        margin-left: 10px;
        &:hover {
          color: rgba(236, 28, 28, 1);
        }
      }
      .setmr-btn {
        float: left;
        font-size: 14px;
        margin-left: 0;
      }
    }
    .mr-label {
      position: absolute;
      left: 0;
      top: 0;
      font-size: 12px;
      color: rgba(236, 28, 28, 1);
      z-index: 5;
    }
  }
  .el-icon-plus {
    cursor: pointer;
    color: #c9bfbf;
    font-size: 80px;
  }
  .switch-style {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #290202a6;
    font-size: 12px;
    margin-top: 3px;
  }
}
.cha-footer {
  margin-top: 10px;
  display: flex;
  justify-content: space-between !important;
}
</style>



// WEBPACK FOOTER //
// components/console/seal/grant.vue